import { useDispatch } from 'react-redux';

import { useInject } from '@vk-hr-tek/core/ioc';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { useIsDesktop } from '@vk-hr-tek/ui/hooks';
import { Redo } from '@vk-hr-tek/ui/Redo';
import { Link } from '@vk-hr-tek/ui/Link';
import { Box } from '@vk-hr-tek/ui/Box';
import { FormButton, FormError, TextInput, Form } from '@vk-hr-tek/app-ui/form';
import { FormKnownValue, FormKnownValues } from '@vk-hr-tek/ui/form';
import { Callout } from '@vk-hr-tek/ui/Callout';
import { Typography } from '@vk-hr-tek/ui/Typography';

import { useSelector } from '@app/hooks';

import {
  candidateLogin,
  candidateLoginInit,
  redirectToCandidateLogin,
  selectInviteCode,
  selectNotification,
  selectPhone,
  selectStatus,
} from '../../../slice';
import { CandidateLoginFinishDto, CandidateLoginInitDto } from '../../../dto';

export const LoginFinish = () => {
  const dispatch = useDispatch();
  const validator = useInject(ValidationService);
  const isDesktop = useIsDesktop();

  const phone = useSelector(selectPhone);
  const error = useSelector(selectNotification);
  const status = useSelector(selectStatus);
  const invite = useSelector(selectInviteCode) ?? '';

  const onSubmit = (values: CandidateLoginFinishDto) => {
    return new Promise((resolve) => {
      dispatch(
        candidateLogin({
          candidateLoginFinishDto: {
            ...values,
            invite,
            phone,
          } as CandidateLoginFinishDto,
          actions: { resolve, reject: resolve },
        }),
      );
    });
  };

  const resendCode = () => {
    return new Promise((resolve) => {
      dispatch(
        candidateLoginInit({
          candidateLoginInitDto: {
            phone,
            invite,
          } as CandidateLoginInitDto,
          actions: { resolve, reject: resolve },
        }),
      );
    });
  };

  const selectAnotherPhone = () => dispatch(redirectToCandidateLogin(invite));

  return (
    <Form
      onSubmit={onSubmit}
      validate={(values) =>
        validator.validate(values, CandidateLoginFinishDto, ['form'])
      }
      render={({
        handleSubmit,
        submitting,
        pristine,
        hasValidationErrors,
        dirtySinceLastSubmit,
      }) => (
        <form onSubmit={handleSubmit}>
          <FormKnownValues>
            <FormKnownValue label="Номер телефона" value={phone} />
          </FormKnownValues>
          <Box mt="24">
            <TextInput
              name="code"
              label="Код подтверждения"
              placeholder="Введите код"
              type="number"
              inputMode="numeric"
              autocomplete="one-time-code"
              id="qaAuthLoginFinishCodeInput"
              testId="test-id-verify-code-input"
            />
          </Box>
          <Box mb="12">
            <Callout>
              <Typography color="text.light.primary" variant="body3">
                Код поступит в MAX или придёт по СМС
              </Typography>
            </Callout>
          </Box>
          <Redo label="Отправить код повторно" action={resendCode} />
          <Box mt={{ xs: '32', md: '48' }}>
            <FormButton
              disabled={pristine || hasValidationErrors}
              loading={submitting}
              testId="test-id-code-accept-button"
            >
              Войти в HR Tek
            </FormButton>
          </Box>
          {!dirtySinceLastSubmit && status && status === 'failed' && (
            <FormError error={error} />
          )}
          <Box
            display="flex"
            mt={{ xs: '24', md: '16' }}
            justifyContent={isDesktop ? undefined : 'center'}
          >
            <Link onClick={selectAnotherPhone} size="small" variant="tertiary">
              Другой номер телефона
            </Link>
          </Box>
        </form>
      )}
    />
  );
};
